import { Button } from '@spiaggeit/spit-ui'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/hooks/store'
import { useTriggerClick } from '@/hooks/timeSchedule/useTriggerClick'
import { Service } from '@/models/service'
import { cartSlice } from '@/store/cartSlice'

interface Props {
  quantity: number
  service: Service
}

export function TimeScheduleMapTrigger(props: Props) {
  const { t } = useTranslation()

  const selectedElementReservation = useAppSelector(
    cartSlice.selectors.selectedElementReservation
  )

  const isEdit = props.quantity > 0

  const { onTriggerClick } = useTriggerClick({
    isEdit,
    reservation: selectedElementReservation,
    service: props.service,
  })

  const triggerLabel = useMemo(() => {
    return t(
      isEdit
        ? 'timeSchedulesDialog.triggerEditSingleDay'
        : 'timeSchedulesDialog.triggerSelectSingleDay'
    )
  }, [isEdit])

  return (
    <Button
      className="self-start rounded"
      onClick={onTriggerClick}
      type="button"
      variant="outline"
    >
      {t(triggerLabel)}
    </Button>
  )
}
